import { cn } from "@/lib/utils";

// Logo lockup: transparent anchor+globe+circuit mark + wordmark.
// variant: "light" (dark text, for white backgrounds) | "dark" (light text, for navy backgrounds)
export const Logo = ({ variant = "light", className, showTagline = false }) => {
  const isDark = variant === "dark";
  return (
    <div className={cn("group/logo flex items-center gap-2.5", className)}>
      <div className="relative grid h-11 w-11 shrink-0 place-items-center transition-transform duration-300 group-hover/logo:scale-105">
        <img
          src={`${process.env.PUBLIC_URL || ""}/anchor-logo.png`}
          alt="Anchor Web Systems logo"
          className="h-full w-full object-contain drop-shadow-[0_2px_10px_rgba(37,99,235,0.35)]"
          loading="eager"
        />
      </div>
      <div className="flex flex-col leading-none">
        <span
          className={cn(
            "font-display text-[15px] font-bold tracking-tight",
            isDark ? "text-navy-foreground" : "text-navy"
          )}
        >
          ANCHOR
          <span className="text-techblue">.</span>
        </span>
        <span
          className={cn(
            "font-display text-[10px] font-medium uppercase tracking-[0.28em]",
            isDark ? "text-navy-muted" : "text-muted-foreground"
          )}
        >
          Web Systems
        </span>
      </div>
    </div>
  );
};
